import {BrowserRouter, redirect, Route, Routes, useNavigate} from "react-router-dom";
import {User, MobileUser, UserContext, useUserContext} from "./context/userContext";
import GlobalLayout from "./components/layout/GlobalLayout";
import './App.css';
import React, {useContext, useEffect, useMemo, useState} from "react";
import {ConfigContext, IConfig, WantsAdminContext, useConfig, useCanBeAdmin} from "./config";
import WaitingForSalesRep from "./components/screens/waitingForSalesRep/WaitingForSalesRep";
import { CustomerClientContext } from "./data/customerSource";
import CustomerClient from "./kova/customerClient";
import { StationContext } from "./data/stationSource";
import Admin from "./components/screens/admin/Admin";
import {UnrealContentContext, UnrealContentProvider} from "./unreal/UnrealContentProvider";
import {useFavorites} from "./data/favoriteManager";
import VscRoutes from "./components/VscRoutes";
import {
    BrowserWindowVisualizerManager,

} from "./visualizers/UnrealVisualizer";
import {VscVisualizerSession} from "./components/visualizer/VscVisualizerSession";
import {useMsal} from "@azure/msal-react";
import {UnrealSignalRVisualizerManager} from "./visualizers/UnrealSignalRVisualizer";
import IndexLogin from "./login/IndexLogin";
import {isSet} from "util/types";
import {VscUnrealSignalRVisualizerManager} from "./visualizers/VscUnrealVisualizer";
import styled from "@emotion/styled/macro";
import LogRocket from "logrocket";


export interface IGlobalConfig {
    /// What is the endpoint for the API server
    server: string;
    /// What endpoint should Unreal load the content from
    contentServer: string;
    stationIds: string[];

    isAdmin:boolean;

}
const AdminStationSelectorMain = styled.main`

    overflow-y: auto;
    display:flex;
    justify-content: center;
    align-items: center;
    div {
        text-align:center;
    }
`
const FullStationSelector: React.FC<{salesCenterId:string, config: IGlobalConfig}> = (props) => {
    const { config, salesCenterId  } = props;

    return <AdminStationSelectorMain>
        <div>
        <img src={"/ClaytonVSC.jpg"}/>
        <GfnStationSelector salesCenterId={salesCenterId} />
            { config.isAdmin && <>
        <h2>Admin access</h2>
        <p>
            <a href={"admin"}>Enter admin pages</a>
        </p>
            <StationSelector salesCenterId={salesCenterId} config={config} />
            </> }

        </div>

    </AdminStationSelectorMain>

}
const ManualStationSection = styled.section`
li { list-style: none; }
    ul { padding:0;}
`
const StationSelector: React.FC<{salesCenterId:string, config: IGlobalConfig}> = ({salesCenterId, config}) => {

    return <ManualStationSection><h2>Manual Station Selection</h2>
        <ul>
        { config.stationIds.map(stationId => <li> <a href={`/sc/${salesCenterId}/${stationId}`}>Station {stationId}</a>
        </li>) }
        </ul>
        <p>Dynamic station</p>

        <form onSubmit={(ev) => {
            var elem = document.getElementById("stationid") as HTMLInputElement;
            document.location = `/sc/${salesCenterId}/${elem.value}`;
            ev.preventDefault();
            return false;
        }}><label>Station ID:<input type={"text"} id={'stationid'}></input></label><input type={'submit'} /></form>

    </ManualStationSection>
}
const GfnSection = styled.section`
display:flex;
    flex-direction: column;
    align-items:center;
    .qr {
        width:14em;
    }

    input.gfnid:valid {
        background-color:lightgreen;
    }
   
`
const GfnStationSelector: React.FC<{salesCenterId:string}> = ({salesCenterId}) => {

    return <GfnSection>
        <img className={"qr"} src={"/gdn-qr.jpg"} />
        <h2>Please enter the station ID from the QR code in GFN.</h2>

        <form onSubmit={(ev) => {
            var elem = document.getElementById("stationid") as HTMLInputElement;

            let stationId = elem.value.toUpperCase();

            if (!stationId.startsWith("gdn")) {
                stationId = "gdn." + stationId;
            }

            document.location = `/sc/${salesCenterId}/${stationId}`;
            ev.preventDefault();
            return false;
        }}><p><label><span />gdn.<input required type={"text"} className={"gfnid"}
                             placeholder={"XXXXXXXX"} pattern={"[0-9A-F]+"}
                             minLength={8}
                             maxLength={8}
                             id={'stationid'}></input></label></p>
            <input type={'submit'} value={"Submit"}/><span/></form>

    </GfnSection>
}

const DataInvalidatorContext = React.createContext<null | (() => Promise<void>)>(null);


export function useDataInvalidation() {
    return useContext(DataInvalidatorContext) as (() => Promise<void>);

}

const AppContent: React.FC<{ salesCenterId: string, serverUri: string }> = (props) => {

    const {salesCenterId, serverUri} = props;

    // const { slsOrds, refresh } = useSlsOrds();
   // const isAvailable = useUnrealStatusCheck();
   // const models = useModels();

   //if (refresh === null) throw "WUT";
    const user = useUserContext();
    const { favorites, updateFavorites} = useFavorites(user.user?.id);
   // if (slsOrds === null || models === null) return <div>Loading... This may take a while when starting the application the first time</div>;
    //const reservedSlsOrds = slsOrds.filter(so => so.reservedTo !== 0);
   // const reservedToYou = reservedSlsOrds.find(so => so.reservedTo === user.user?.id);


    const isAvailable = true; const reservedToYou = undefined;
    return <GlobalLayout>
        <DataInvalidatorContext.Provider value={async () => {}}>
            { !isAvailable && <div>Waiting for Unreal...</div> }
            { isAvailable && reservedToYou !== undefined && <WaitingForSalesRep reservedSlsOrd={reservedToYou} /> }
            { isAvailable && reservedToYou === undefined && <VscRoutes serverUri={serverUri} salesCenterId={salesCenterId} favorites={favorites} updateFavorites={updateFavorites}/> }
        </DataInvalidatorContext.Provider>
    </GlobalLayout>


}

interface IStationConfig {
    visualizer: "unreal" | "browser" | "vsc-unreal";
    token: string; // Authentication token to be given to Unreal.
}
type ErrorType = "network" | "stationnotfound" | "unknown";
const StationContent: React.FC<{stationId:string, salesCenterId:string, serverUri:string, contentUri:string, isAdmin:boolean}> = (props) => {
    const { stationId, serverUri, contentUri, salesCenterId, isAdmin } = props;

    const [user, setUser] = useState<User | undefined>(undefined);
    const [wantsAdmin, setWantsAdmin] = useState<boolean>(false);
    const [mobileUser, setMobileUser] = useState<MobileUser | undefined>(undefined);
    const [community, setCommunity] = useState<string | undefined>(undefined);
    const [error, setError] = useState<{type:ErrorType, errorText:string}|undefined>(undefined);

    const [stationConfig, setStationConfig] = useState<IStationConfig|undefined>(undefined);
    useEffect(() => {
        const manifestNode = document.head.querySelector("link[rel='manifest']");
        if (manifestNode !== null) { manifestNode.remove(); }
        const newNode = document.createElement("link");
        newNode.setAttribute("rel", "manifest");
        newNode.setAttribute("href", serverUri + "manifest");

        document.head.appendChild(newNode);
    })
    useEffect(() => {

        fetch(serverUri + "config").then(res => {
            if (res.status === 401) {
                setError({type: "unknown", errorText: "Access denied"});
                return;
            }
            if (res.status === 404) {
                setError({type: 'stationnotfound', errorText: "Station configuration not found!"});
            }
            if (!res.ok) {
                return res.text().then(errText => setError({type: 'unknown', errorText: errText}));
            }

            res.json().then(configJson => setStationConfig(configJson));
        }).catch(err => {
            console.log('received error!');
            setError({ type: "network", errorText: "Network Error"});
        });

    }, [stationId]);
    useEffect(() => {

        return;
        const eventListener = () => {
            if (document.visibilityState === "hidden") {
                setUser(undefined);
                document.location = `/sc/${encodeURIComponent(salesCenterId)}/${encodeURIComponent(stationId)}`;
            }
            ;
        }
        document.addEventListener("visibilitychange", eventListener);

        return () => document.removeEventListener("visibilitychange", eventListener);
    }, [stationId]);

    const visualizer = useMemo(() => {

        if (stationConfig === undefined) return undefined;
        if (stationConfig.visualizer === "unreal") {
            return new UnrealSignalRVisualizerManager(serverUri, salesCenterId, stationId, stationConfig.token);
        }
        if (stationConfig.visualizer === "vsc-unreal") {
            return new VscUnrealSignalRVisualizerManager(serverUri, salesCenterId, stationId, stationConfig.token);
        }
        return new BrowserWindowVisualizerManager();
    }, [stationConfig]);

    const customerClient = new CustomerClient({serverUri});

    if (error) {
        return <main>
            <h1>
                Error
            </h1>
            <p>{error.errorText}</p>
            <p>Click the button below to reload</p>
            <button onClick={() => { window.location = window.location; } }>Reload</button>
        </main>;
    }


    if (stationConfig === undefined || visualizer === undefined) return <div>Loading...</div>;

    let contentUriToUse = (stationConfig.visualizer === "unreal" || stationConfig.visualizer === "vsc-unreal") ? contentUri : serverUri;

    const unrealContentProvider = new UnrealContentProvider(contentUriToUse);






    return (
        <BrowserRouter basename={"/sc/" + salesCenterId + "/" + stationId}>
            <ConfigContext.Provider value={{server: serverUri, contentServer: contentUriToUse, isAdmin: isAdmin}}>
                <WantsAdminContext.Provider value={[wantsAdmin, setWantsAdmin]}>
                <UnrealContentContext.Provider value={unrealContentProvider}>
                    <StationContext.Provider value={stationId}>
                        <UserContext.Provider value={{user, setUser, mobileUser, setMobileUser}}>

                                    <CustomerClientContext.Provider value={customerClient}>

                                            <VscVisualizerSession visualizer={visualizer}>

                                            <AppContent serverUri={serverUri} salesCenterId={salesCenterId}></AppContent>
                                            </VscVisualizerSession>
                                    </CustomerClientContext.Provider>
                        </UserContext.Provider>
                    </StationContext.Provider>
                </UnrealContentContext.Provider>
                </WantsAdminContext.Provider>
            </ConfigContext.Provider>

        </BrowserRouter>

    );
}


const SalesCenterApp: React.FC<{salesCenterId:string, onSessionExpired: () => void}> = ({salesCenterId, onSessionExpired}) => {


    //var search = new URLSearchParams(document.location.search);
    //const server = search.get("server");
//    const server = "http://oakwood.vsc.bimairedev.localhost:5081";
    const server = undefined;



    const configUrl = `${server ?? ""}/sc/${salesCenterId}/config.json`;


    const [config, setConfig] = useState<IGlobalConfig | null>(null);

    const [error, setError] = useState<string|null>(null);


    const { instance, accounts, inProgress } = useMsal();

    useEffect(() => {
        fetch(configUrl).then(res => {
            if (res.status == 401) {
                window.location.href = "/?redirect=" + window.location.pathname;
                return;
            }
            if (!res.ok) {
                return res.text().then(errText => setError(errText));
            }
            return res.json().then(resJson => setConfig(resJson));
        }).catch(err => {
            console.log(err);
        });

    }, [configUrl]);

    if (error !== null) {
        return <main><h1>Error</h1><p>{error}</p></main>;
    }
    if (config === null) return null;


    const url = window.location.pathname;

    const stationUrlMatch = url.match(/\/sc\/([^\/]+)\/([^\/]+).*/);

    if (!stationUrlMatch) {
        return <FullStationSelector salesCenterId={salesCenterId} config={config} />

    }
    const stationId = stationUrlMatch[2];

    const contentUri = `${config.contentServer}sc/${salesCenterId}/${stationId}/`;


    //const serverUri = stationId.startsWith("admin") ? contentUri : `${config.server}sc/${salesCenterId}/${stationId}/`

    //const isUsingBrowserUrl = window.location.hostname.startsWith("browser.")

    const hostName = window.location.hostname;
    const isUsingControllerUrl = hostName.startsWith("tls-") || hostName.startsWith("vscserver.");
    const isUsingBrowserUrl = !isUsingControllerUrl;

    const serverUri = isUsingBrowserUrl ? contentUri : `${config.server}sc/${salesCenterId}/${stationId}/`;



    if (stationId === "admin") {
        return <Admin config={config} serverUri={serverUri} salesCenterId={salesCenterId} />;
    }

    return <StationContent salesCenterId={salesCenterId}
                           stationId={stationId}
                           serverUri={serverUri}
                           contentUri={contentUri}
                           isAdmin={config.isAdmin}
                           />;
}
const SalesCenterSelectorMain = styled.main`
display:flex;
    align-items:center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    button {
        padding: 3em 10em 3em 10em;
        font-size:x-large;
    }
`
const SalesCenterSelector: React.FC<{}> = (props) => {
    const { accounts } = useMsal();

    const account = accounts.length > 0 && accounts[0];

    const canBeAdmin = account && account.idTokenClaims?.roles?.includes("Vsc.Admin");

    if (account && account.name) {
        LogRocket.identify(account.name);
    }

    const onSubmit = (ev:React.FormEvent<HTMLFormElement>) => {

        const fd = new FormData(ev.target as HTMLFormElement);
        const salescenterId = fd.get("sc");
        ev.preventDefault();
        document.location = "/sc/" + salescenterId + "/";
        return true;


    }
    return <SalesCenterSelectorMain>
        <img src={"/ClaytonVSC.jpg"}/>
        { account && <h3>Welcome, { account.name }</h3> }
        <button onClick={() => document.location = '/sc/global/'}>Start VSC</button>
        { canBeAdmin && <>
        <h2>Manual sales center selection</h2>
        <form onSubmit={onSubmit}>

            <p><label>Sales Center:
                <input type={"text"} name={"sc"}/>
            </label>
            </p>
            <input type={'submit'}/>

        </form>
        </> }
    </SalesCenterSelectorMain>
}

const App: React.FC = (props) => {
    const url = window.location.pathname;
    const [loggedIn, setHasLoggedIn] = useState<boolean|string>(false);


    const salesCenterUrlMatch = url.match(/\/sc\/([^\/]+).*/);
    if (typeof loggedIn == 'string') {
        return <div>{loggedIn}</div>
    }
    const query = new URLSearchParams(window.location.search);
    if (query.has("redirect")) {
        if (!salesCenterUrlMatch && loggedIn) {

            window.location.href = query.get("redirect") ?? "/sc/global";
        }
    }
    if (!salesCenterUrlMatch && !loggedIn) return <IndexLogin hasLoggedIn={loggedIn} setHasLoggedIn={setHasLoggedIn} />;

    if (!salesCenterUrlMatch && loggedIn) return <SalesCenterSelector />
    const salesCenterId = salesCenterUrlMatch![1];
    return <SalesCenterApp salesCenterId={salesCenterId} onSessionExpired={() => setHasLoggedIn(false)}></SalesCenterApp>

}
export default App;
